import React, { useEffect } from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const IzbNationalAssembly14thParliamentInduction = () => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}
            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Indo Zambia Bank Partners with National Assembly for 14th Parliament Induction Programme</h1>

                    <p className="pb-3">Indo Zambia Bank is honoured to partner with the National Assembly of Zambia in the ongoing Induction Programme of the 14th Parliament for Newly Elected and Nominated Members of Parliament (MPs). We congratulate all MPs and reaffirm our commitment to supporting national development through various innovative financial solutions and strategic partnerships that contribute both to their constituencies and the Grow Zambia Agenda.</p>

                    <p className="pb-3">We are also showcasing a range of banking products and services at our stand during the programme and invite all MPs to visit us and learn more on how we can support the development aspirations of their constituencies and the Grow Zambia Agenda. Guided by our brand promise, "Supporting You, Developing Zambia," we remain dedicated to contributing to Zambia's socio-economic growth.</p>

                    <p className="pb-3"><b><em>#IndoZambiaBank #NationalAssembly #14thParliament #GrowZambiaAgenda</em></b></p>

                    <h2 className="pt-5 pb-4 text-left">Gallery</h2>
                    <Slider {...settings}>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/WhatsApp-Image-2026-09-29-1.18.23-PM.jpeg" style={{ width: "100%", height: "500px", objectFit: "cover" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/WhatsApp-Image-2026-09-29-1.18.22-PM.jpeg" style={{ width: "100%", height: "500px", objectFit: "cover" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/WhatsApp-Image-2026-09-29-1.18.23%20PM-(1).jpeg" style={{ width: "100%", height: "500px", objectFit: "cover" }} alt="Gallery" />
                        </div>
                    </Slider>
                </div>
            </section>

            <CustomerCare />
            <OurStores />
        </>
    );
};

export default IzbNationalAssembly14thParliamentInduction;
